<template>
    <v-card class="mb-12">
        <v-card-title class="px-8">
            <v-row>
                <v-col>
                    Annuities
                </v-col>
            </v-row>
<!--            <v-col sm="4" md="2" class="justify-end d-flex align-center">-->
<!--                <v-btn @click="addAccount" class="ma-1 d-flex white&#45;&#45;text" color="#1D5BE5" rounded depressed small>-->
<!--                    Add new annuity-->
<!--                </v-btn>-->
<!--            </v-col>-->
        </v-card-title>
        <v-data-table
            dense
            :headers="headers"
            :items="accounts"
            :items-per-page="accounts.length"
            class="account-table"
            :loading="loading"
            :mobile-breakpoint="0"
        >
            <template v-slot:item.iav_account.individual_id="{ item }">
                {{ getAccountName(item.iav_account) }}
            </template>
            <template v-slot:item.iav_account.value="{ item }">
                {{ item.iav_account.value | money }}
            </template>
            <template v-slot:item.iav_account.annuity_value="{ item }">
                {{ item.iav_account.annuity_value | money }}
            </template>
            <template v-slot:item.iav_account.health_care_multiplier="{ item }">
                {{ item.iav_account.health_care_multiplier | money }}
            </template>
            <template v-slot:item.iav_account.health_care_rider="{ item }">
                {{ item.iav_account.health_care_rider | money }}
            </template>
            <template v-slot:item.iav_account.deposits="{ item }">
                {{ item.iav_account.deposits | money }}
            </template>
            <template v-slot:item.iav_account.withdrawals="{ item }">
                {{ item.iav_account.withdrawals | money }}
            </template>
            <template v-slot:item.iav_account.account_start_value="{ item }">
                {{ item.iav_account.account_start_value | money }}
            </template>
            <template v-slot:item.iav_account.return_percentage="{ item }">
                {{ item.iav_account.return_percentage | percentage }}
            </template>
<!--            <template v-slot:item.actions="{ item }">-->
<!--                <v-icon-->
<!--                    small-->
<!--                    class="mr-2"-->
<!--                    @click="editAccount(item)"-->
<!--                >-->
<!--                    mdi-pencil-->
<!--                </v-icon>-->
<!--                <v-icon-->
<!--                    small-->
<!--                    @click="deleteAccount(item)"-->
<!--                >-->
<!--                    mdi-delete-->
<!--                </v-icon>-->
<!--            </template>-->
        </v-data-table>
        <annuity-modal v-model="showModal" :household-id="user.household_id" :annuity="selectedAnnuity" :key="selectedAnnuityKey" @reload="loadAccounts" />
    </v-card>
</template>

<script>
import {mapGetters} from "vuex";
import axios from "axios";
import AnnuityModal from "@/components/accounts/AnnuityModal";

export default {
    name: "annuities",
    components: {
        AnnuityModal,
    },
    props: {
        showPerformance: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters('household', [
            'getAccountName',
        ]),
        ...mapGetters('constants', [
            'getAccountType',
        ]),
        ...mapGetters('auth', [
            'user',
        ]),
        selectedAnnuityKey() {
            if (this.selectedAnnuity === null) {
                return null;
            }

            return this.selectedAnnuity.id;
        },
        headers() {
            let headers = [
                { text: 'Owner', value: 'iav_account.individual_id' },
                { text: 'Open Date', value: 'iav_account.open_date' },
                { text: 'Company', value: 'iav_account.company_name' },
                { text: 'Acct Number', value: 'iav_account.account_number' },
                { text: 'Balance', value: 'iav_account.value' },
                { text: 'Income Value', value: 'iav_account.annuity_value' },
                { text: 'Health care Multiplier', value: 'iav_account.health_care_multiplier' },
                { text: 'Health care Rider', value: 'iav_account.health_care_rider' },
                { text: 'Deposits', value: 'iav_account.deposits' },
                { text: 'Withdrawals', value: 'iav_account.withdrawals' },
                { text: 'Initial Deposits', value: 'iav_account.account_start_value' },
                { text: 'From', value: 'from' },
                { text: 'Series', value: 'series' },
                { text: 'Rider', value: 'rider' },
            ];

            if (this.showPerformance) {
                headers = [
                    ...headers,
                    { text: 'Deposits', value: 'iav_account.deposits' },
                    { text: 'Withdrawals', value: 'iav_account.withdrawals' },
                    { text: 'Initial Deposits', value: 'iav_account.account_start_value' },
                    { text: 'Return', value: 'iav_account.return_percentage' },
                ]
            }

            return headers;
        }
    },
    data() {
        return {
            loading: false,
            accounts: [],
            showModal: false,
            selectedAnnuity: null
        }
    },
    mounted() {
        this.loadAccounts();
    },
    methods: {
        loadAccounts() {
            axios.get('/api/households/' + this.user.household_id + '/account-manager-annuities', { showLoader: false })
                .then(response => {
                    this.accounts = response.data.data.accountManagerAnnuities;
                });
        },
        addAccount() {
            this.selectedAnnuity = null;

            this.showModal = true;
        },
        deleteAccount(annuity) {
            let reply = confirm('Are you sure you want to destroy this annuity?');

            if (!reply) {
                return false;
            }

            axios.delete('/api/households/' + this.user.household_id + '/account-manager-annuities/' + annuity.id, { showLoader: false })
                .then(() => this.loadAccounts());
        },
        editAccount(brokerageAccount) {
            let selectedAnnuity = {...brokerageAccount};

            this.selectedAnnuity = {...selectedAnnuity.iav_account};

            this.selectedAnnuity.id = selectedAnnuity.id;
            this.selectedAnnuity.health_care_multiplier = selectedAnnuity.health_care_multiplier;
            this.selectedAnnuity.health_care_rider = selectedAnnuity.health_care_rider;
            this.selectedAnnuity.from = selectedAnnuity.from;
            this.selectedAnnuity.series = selectedAnnuity.series;
            this.selectedAnnuity.rider = selectedAnnuity.rider;
            this.selectedAnnuity.active = selectedAnnuity.active;
            this.selectedAnnuity.date_of_entry = selectedAnnuity.date_of_entry;

            this.showModal = true;
        }
    }
}
</script>

